import React, { Component } from 'react';
import axios from '../../axios-instance';
import classes from './Wallet.module.scss';
import Button from '../UI/Button/Button';
import ResponsiveDialog from '../UI/ResponsiveDialog/ResponsiveDialog';
import CatchHeader from '../UI/CatchHeader/CatchHeader';

class Wallet extends Component {

    state = {
        content: [],
        showModal: false,
        message: ''
    }

    componentDidMount() {
        console.log(this.props.device);
        this.getDeviceContent() 
    }

    getDeviceContent = async() => {
        try {
            const res = await axios.get(`/device/${this.props.device.uuid}/content?status=[2,3,4,5]&sort_by=updated_at&sort_order=desc`, {
                headers: {
                    'x-device-uuid': `${this.props.device.uuid}`
                }
            });
            if (res && res.data) {
                let content = res.data.slice();
                this.setState({content: content})
            }
        } catch(err) {
            console.error('Error: ', err)
        }
    }

    onClearWallet = async() => {
        try {
            const res = await axios.delete(`/device/${this.props.device.uuid}/content`, {
                headers: {
                    'x-device-uuid': `${this.props.device.uuid}`
                }     
            });
            if (res) {
                if (res.status === 200) {
                    this.setState({
                        showModal: true,
                        message: res.data.message
                    });
                }
            }
        } catch(err) {
            this.setState({
                showModal: true,
                message: 'Error clearing wallet'
            })
        }
    }

    closeModal = () => {
        this.setState({showModal: false})
    }

    updateStatus = async (content) => {
        try {
          const uri = `/device/${this.props.device.uuid}/content/${content.id}?status=${6}`;
          const res = await axios.put(
            uri,
            {},
            {
              headers: {
                'Content-Type': 'application/json',
                'x-device-uuid': `${this.props.device.uuid}`
              }
            }
          );
          if (res && res.status === 200) {
            if (res.data && res.data.message) {
              console.log(res.data.message);
            }
          }
        } catch (err) {
            console.error('Error: ', err);
        }
    };
    
    render() {
        return (
            <div className={classes.Container}>
                <ResponsiveDialog
                    walletModal={true}
                    open={this.state.showModal}
                    onClose={() => this.closeModal()}>
                       {this.state.message}
                </ResponsiveDialog>
                <div className={classes.WalletContainer}>
                    <div className={classes.WalletCopyContainer}>
                        <div className={classes.WalletTitle}>
                            Oh, hello there!
                        </div>
                        <div className={classes.WalletCopy}>
                            Looking to clear out your ACTV8me Wallet? Tap the button below and we’ll take care of the rest.
                        </div>
                        <div className={classes.ButtonContainer}>
                            <Button onClick={this.onClearWallet} btnText={'Clear Wallet'}></Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default Wallet;
